module.exports = __webpack_public_path__ + "static/media/20020619_1.1850fa75.jpg";